import rtoIndore from '../assets/login-slider/rto-indore.png';
import schoolTransport from '../assets/login-slider/school-transport.placeholder.svg';
import verification from '../assets/login-slider/verification.placeholder.svg';
import portalDashboard from '../assets/login-slider/portal-dashboard.mock.svg';

// Only local assets. Approval/replacement instructions are in assets/login-slider/README.md.
export const loginSlides = [
  {
    image: rtoIndore,
    heading: 'Safer School Transport for a Brighter Future',
    tagline: 'सुरक्षित विद्यालय, सुरक्षित परिवहन, सुरक्षित भविष्य',
    lang: 'hi',
    alt: 'RTO Indore office at Nayta Mundla',
    placeholder: false,
    photograph: true,
    imageFit: 'cover',
  },
  {
    image: schoolTransport,
    heading: 'Safer School Transport',
    tagline: 'Secure vehicles, verified staff, safer journeys',
    alt: 'Local illustration of supervised school bus boarding, not an official photograph',
    placeholder: true,
    assetNote: 'School safety illustration · Photograph pending',
    imageFit: 'contain',
  },
  {
    image: verification,
    heading: 'Verified Drivers & Vehicles',
    tagline: 'RC, Fitness, Permit, PUC and staff verification in one system',
    alt: 'Local illustration of a school bus inspection and compliance checklist',
    placeholder: true,
    assetNote: 'Verification illustration · Photograph pending',
    imageFit: 'contain',
  },
  {
    image: portalDashboard,
    heading: 'Smart Digital Monitoring',
    tagline: 'Manage schools, buses, drivers, conductors and reports from one portal',
    alt: 'Portal UI mock showing the actual dashboard sections and navigation for schools, buses, drivers, conductors and MIS reports; no live data',
    placeholder: false,
    assetNote: 'Portal UI illustration · Not a live dashboard',
    imageFit: 'contain',
  },
];
